import { useQuery } from '@tanstack/react-query'

import { ICurrentProvider } from '@/app/providers/CurrentProvider'

import parseCsv from '../../../../helpers/parseCsv'
import EnvironmentProvider, { useEnvironment } from '../../../providers/EnvironmentProvider'
import ICandidato from '../types/ICandidato'

export interface IElectionData {
  candidatos?: ICandidato[]
  lastUpdate: Date
}
interface ICurrentPrevia {
  Previa: string
}
type TPrevia = string

export interface ICandidatosDataProvider<T = unknown> extends ICurrentProvider<T> {
  electionData: IElectionData
}

export type ICandidatosDataEnv = ICandidatosDataProvider<ICurrentPrevia>

const CandidatosDataProvider = (props: object) => {
  const { currents, requests } = useEnvironment<ICandidatosDataProvider<ICurrentPrevia>>()
  const previaCurrent = currents['previa']?.Previa
  const date = previaCurrent?.split('data_')[1].replace('.csv', '')
  const lastUpdate = new Date(date)

  const queryParams = ({ enabled, url }: { url?: string; enabled?: boolean }) =>
    [[url], () => requests['2023_consejeros']({ method: 'GET', url }), { enabled }] as const

  const { data: candidatosCsv } = useQuery<unknown, unknown, TPrevia>(
    ...queryParams({
      enabled: Boolean(previaCurrent),
      url: previaCurrent,
    })
  )

  const electionData: IElectionData = {
    candidatos: candidatosCsv ? parseCsv<ICandidato>(candidatosCsv) : undefined,
    lastUpdate,
  }

  return (
    <EnvironmentProvider
      env={{ electionData }}
      {...props}
    />
  )
}

export default CandidatosDataProvider
